import _objectSpread from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Screenfull from '@/components/Screenfull';
import { mapState } from 'vuex';
export default {
  name: 'Bhxc',
  components: {},
  data: function data() {
    return {
      warningDeviceVisible: false,
      isLoad: false,
      areaCode: 2915,
      showModel: '',
      ljdhDialog: false,
      boxVisible: false,
      // 是否打开视频弹框
      videoUrl: '',
      // 视频地址
      videoBoxTitle: '',
      sysType: '',
      // 设备类型
      mapTitle: '智慧路灯详情',
      equipmentVisible: false,
      mapSrc: '',
      sbjkData: [],
      countOrderData: [],
      countOrderFifeenDayData: [],
      countTodayAlarmData: [],
      findDeviceMonitorWaterData: [],
      findDeviceMonitorEnivronmentData: [],
      waterOptions: [],
      waterId: '',
      environmentOptions: [],
      environmentId: '',
      thisTime: null,
      alarmNum: 0,
      alarmMusic: null,
      warnBoxVisible: false,
      videoUrl1: '',
      videoUrl2: '',
      parkingListVisible: false,
      accessListVisible: false,
      elevatorMonitorVisible: false,
      intelligentGuardVisible: false,
      parkingVisible: false,
      videoVisible: false,
      checkIndex: '1',
      intelligentGuardList: [],
      doorDetail: [],
      // 进出监控的门禁进出监控列表,
      parkingDetail: [],
      // 停车进出监控列表
      baVisible: false,
      mailBoxModel: [],
      weatherModel: [],
      linkageVisible: false,
      linkageData: null,
      total: null,
      listQuery: {
        page: 1,
        limit: 10
      }
    };
  },
  created: function created() {},
  beforeDestroy: function beforeDestroy() {},
  mounted: function mounted() {
    // 监听子页面传递的数据
    window.addEventListener('message', this.listenerEvent); // 修改子页面的样式

    if (document.getElementById('MapMain')) {
      var dom = document.getElementById('MapMain').contentWindow.document.getElementById('gameContainer');

      if (dom) {
        dom.style.overflow = 'hidden';
      }
    }
  },
  computed: _objectSpread({}, mapState({
    isReal: function isReal(state) {
      return state.user.isReal;
    },
    realFilter: function realFilter(state) {
      return state.user.realFilter;
    },
    isRefresh: function isRefresh(state) {
      return state.user.refreshInfo.alarmRefresh;
    }
  })),
  methods: {
    logout: function logout() {
      var _this = this;

      this.$confirm('准备退出系统, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.$store.dispatch('LogOut').then(function () {
          // location.href = 'http://' + window.location.host + '/login'
          location.reload(); // In order to re-instantiate the vue-router object to avoid bugs
        });
      }).catch(function () {});
    },
    manage: function manage() {
      this.$router.push({
        name: 'dashboard'
      });
    }
  }
};